"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bytes_1 = require("./bytes");
class Operands {
    static SIPUSH(operands) {
        try {
            return bytes_1.readInt16BE(operands);
        }
        catch (err) {
            console.log(err);
            return null;
        }
    }
    static BIPUSH(operands) {
        try {
            return bytes_1.readInt8BE(operands);
        }
        catch (err) {
            console.log(err);
            return null;
        }
    }
}
exports.default = Operands;
